/**
 * The photo a Create modal "Photo → text" step handed to the note it just
 * made. The modal creates the note only once a file arrives, then the note
 * page takes the file and reads it, with no second picker: a picker opened
 * after the create round trip ran outside the click's user activation, and
 * the browser could refuse it.
 *
 * A plain module map, not a store anyone subscribes to: the note page takes
 * its file once, on arrival. Not persisted (a `File` does not survive a
 * reload, and a reload must not re-run the OCR).
 */

const pending = new Map<string, File>();

/** Hold `file` for the note `noteId` until its page takes it. */
export function putPendingCaptureFile(noteId: string, file: File): void {
  pending.set(noteId, file);
}

/** The file waiting for `noteId`, removed as it is taken; at most once. */
export function takePendingCaptureFile(noteId: string): File | undefined {
  const file = pending.get(noteId);
  pending.delete(noteId);
  return file;
}
